import React from 'react';
import { Link } from 'react-router';
import Moment from 'moment';
import MomentRu from 'moment/locale/ru';


class Item extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            info: {
                id: props.id,
                uuid: props.uuid,
                category: props.category,
                created_at: props.created_at,
                feed_date: props.feed_date,
                title: props.title,
                source_name: props.source_name,
                anons: props.anons,
                description: props.description,
                selected: props.selected
            },
            selected: false
        };
    }

    componentWillReceiveProps(props) {

        this.setState({
            info: {
                id: props.id,
                uuid: props.uuid,
                category: props.category,
                created_at: props.created_at,
                feed_date: props.feed_date,
                title: props.title,
                source_name: props.source_name,
                anons: props.anons,
                description: props.description,
                selected: props.selected
            }
        });
    }

    __formatDate(date) {
        let current_date = (new Date()).getTime();
        let input_date = new Date(date);
        let delta = current_date - input_date.getTime();
        return (delta > 24 * 60 * 60 * 1000) ? Moment(input_date).format('DD.MM.YYYY H:mm') : Moment(input_date).format('H:mm');
    }

    __linkClickHandler(event) {
        event.preventDefault();
    }

    checkboxChangeHandler(event) {
        let selected = !this.state.selected;
        this.setState({selected});
    }

    selectItem(event) {
        this.props.onSelectItem(this.state.info.id);
    }

    clickHandler(event) {
        event.preventDefault();
        this.props.more(this.state.info);
    }

    render() {
        let className = ['m2feed_item'];
        let checkbox = (this.props.selected) ? <input className="m2checked" type="checkbox" onClick={this.selectItem.bind(this)} checked={true}/> : <input type="checkbox" onClick={this.selectItem.bind(this)} checked={false}/>;
        return (
            <div className={className} onClick={this.clickHandler.bind(this)}>
                <div className="m2feed_item_source">
                    <Link to="#" onClick={this.__linkClickHandler.bind(this)} ><span>{this.state.info.source_name}</span></Link>
                    <div className="m2feed_date"><span>{this.__formatDate(this.state.info.feed_date)}</span></div>
                </div>
                <div className="m2feed_item_wrapper" unselectable="no">
                    <div className="m2feed_option_checkbox">
                        {this.state.info.selected}
                        <div className="m2checkbox2">
                            {checkbox}
                        </div>
                    </div>
                    <div className="m2feed_item_info" unselectable="no">
                        <div className="m2feed_item_title"><Link onClick={this.__linkClickHandler.bind(this)} unselectable="no" to="#" dangerouslySetInnerHTML={{__html: this.state.info.title}}></Link></div>
                        <div className="m2feed_item_anons"><Link onClick={this.__linkClickHandler.bind(this)}  unselectable="no" to="#" dangerouslySetInnerHTML={{__html: this.state.info.anons}}></Link></div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Item;


// WEBPACK FOOTER //
// ./src/components/Bookmarks/Item.js